import React from 'react';
import { graphql } from 'gatsby';
import { Meta } from 'react-head';

import BlogPostTeaser from '../../02-molecules/BlogPostTeaser/BlogPostTeaser';
import BlogPostTeasersList from '../../03-organisms/BlogPostTeasersList/BlogPostTeasersList';
import Pagination from '../../02-molecules/Pagination/Pagination';
import SEO from '../../01-atoms/SEO/SEO';

const Page = ({
  data,
  location,
  pageContext: {
    category,
    humanPageNumber,
    nextPagePath,
    numberOfPages,
    openGraphImageUrl,
    pageNumber,
    previousPagePath,
  },
}) => (
  <>
    <SEO location={location} title={category} />

    <Meta content={openGraphImageUrl} name="twitter:image" />
    <Meta content={openGraphImageUrl} name="og:image" />
    <Meta content="1200" name="og:image:width" />
    <Meta content="630" name="og:image:height" />

    {!!data?.postsData?.posts?.length && (
      <BlogPostTeasersList layout="simple" semanticLevel={1} title={category}>
        {data.postsData.posts.map((post, i) => {
          const { description, featured_image, title } = post.frontmatter;
          const slug = post?.fields?.slug;
          return (
            <BlogPostTeaser
              description={description}
              image={featured_image}
              imageLoading={i < 2 ? `eager` : `lazy`}
              key={slug}
              semanticLevel={2}
              title={title}
              to={`/blog/post/${post?.fields?.slug}`}
            />
          );
        })}
      </BlogPostTeasersList>
    )}

    <Pagination
      humanPageNumber={humanPageNumber}
      nextPagePath={nextPagePath}
      numberOfPages={numberOfPages}
      pageNumber={pageNumber}
      previousPagePath={previousPagePath}
    />
  </>
);

export const query = graphql`
  query($category: String, $skip: Int!, $limit: Int!) {
    postsData: allMdx(
      skip: $skip
      limit: $limit
      filter: {
        frontmatter: { categories: { eq: $category } }
        fileAbsolutePath: { regex: "//src/_content/blog/markdown//" }
      }
      sort: { fields: frontmatter___date_published, order: DESC }
    ) {
      posts: nodes {
        body
        fields {
          slug
        }
        frontmatter {
          date_published
          description
          featured_image {
            alt
            src {
              childImageSharp {
                gatsbyImageData(
                  height: 450
                  width: 450
                  placeholder: TRACED_SVG
                  layout: CONSTRAINED
                )
              }
            }
          }
          tags
          title
        }
      }
    }
  }
`;

export default Page;
